/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/prop-types */
import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { faEye, faLock, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Input, Select, Typography, Upload, message } from 'antd';
import moment from 'moment';
import Router from 'next/router';
import { changeStatusAction, getProjectDetail, updateReport, uploadFile } from '@gtintel/platform-api';
import { CLOSED_ID, COMPLETE_ID, COOKIE_NAMES, PROJECT_REPORT_STATE, REPORT_SELECTION_PERMISSION, REPORT_TYPE } from '@gtintel/platform-constants';
import { DEFAULT_DATE_TIME_NOW } from '@gtintel/platform-constants';
import { sendNotifications } from '@gtintel/platform-firebase';
import { getOriginalFileName, getSessionStorageItem } from '@gtintel/platform-utils';
import { onChange } from './../../ReportsTab/utils';
import QANotice from './QANotice';
import * as S from './styles';
const {
  Title
} = Typography;
const {
  Option
} = Select;
const {
  TextArea
} = Input;
const DEFAULT_STATE = {
  isNameValid: true,
  name: '',
  execSummary: null,
  attachmentPermission: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC,
  attachments: [],
  isPublic: false,
  checkExecSummary: true
};
class UpdatePartnerReport extends React.Component {
  constructor(props) {
    super(props);
    this.getReport = () => {
      this.setState({
        ...DEFAULT_STATE,
        previewReport: true
      });
      const {
        report
      } = this.props;
      if (!report) {
        return;
      }
      this.setState({
        name: report.name
      });
      let execSummary;
      const attachments = [];
      if (report.state.value == 2) {
        this.setState({
          isPublic: true
        });
      }
      if (report.projectreportsdetails === undefined || report.projectreportsdetails.length === 0) {
        return;
      }
      report.projectreportsdetails.forEach(value => {
        switch (value.type) {
          case REPORT_TYPE.REPORTSECTIONTYPE_SUMMARY:
            execSummary = {
              id: value.id,
              publish: value.permission,
              content: value.value
            };
            this.setState({
              checkExecSummary: false
            });
            break;
          case REPORT_TYPE.REPORTSECTIONTYPE_ATTACHMENT:
            attachments.push({
              uid: value.id,
              name: value.filename ?? getOriginalFileName(value.value),
              status: 'done',
              thumbUrl: value.value,
              url: value.value
            });
            this.setState({
              attachmentPermission: value.permission
            });
            break;
          default:
            break;
        }
      });
      this.setState({
        attachments,
        execSummary
      });
    };
    this.previewReport = () => {
      if (this.state.name.length === 0) {
        this.setState({
          isNameValid: false
        });
      } else {
        this.setState({
          previewReport: true
        });
      }
    };
    this.stopPreviewReport = () => {
      this.setState({
        previewReport: false
      });
    };
    this.onFinish = async () => {
      this.setState({
        isSubmitting: true
      }, async () => {
        const dateNow = moment().format(DEFAULT_DATE_TIME_NOW);
        const {
          execSummary,
          attachments,
          name
        } = this.state;
        if (name.length === 0) {
          this.setState({
            isNameValid: false,
            isSubmitting: false
          });
          return;
        }
        const reportDetails = [];
        if (execSummary) {
          const payload = {
            type: REPORT_TYPE.REPORTSECTIONTYPE_SUMMARY,
            value: execSummary.content,
            permission: execSummary.publish,
            updated_date: dateNow,
            order: 1 // this is required by the BE which we're avoiding changing:
            // There are existing reports that use the fields we're removing,
            // so we want the backend to continue to support these until we remove those reports,
            // at which point we can refactor and simplify the backend.
          };
          if (execSummary.id !== undefined) {
            payload['id'] = execSummary.id;
          }
          reportDetails.push(payload);
        }
        attachments.forEach((value, i) => {
          const id = Number(value.uid);
          reportDetails.push({
            id: Number.isNaN(id) ? null : id,
            type: REPORT_TYPE.REPORTSECTIONTYPE_ATTACHMENT,
            value: value.thumbUrl,
            permission: this.state.attachmentPermission,
            created_date: dateNow,
            order: i + 1
          });
        });
        const projectReportData = {
          id: this.props.report.id,
          name,
          state: this.state.isPublic ? PROJECT_REPORT_STATE.PUBLIC : PROJECT_REPORT_STATE.DRAFT,
          client_accept: false,
          updated_date: dateNow,
          project_id: this.props.projectId,
          projectreportsdetails: reportDetails,
          published_date: this.state.isPublic ? dateNow : null
        };
        const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
        const {
          status_display
        } = await getProjectDetail(Number(this.props.projectId));
        if (status_display === 'Closed') {
          setTimeout(() => {
            Router.reload();
          }, 1000);
          return message.error(`Update failed, project closed!`);
        }
        updateReport(projectReportData, this.props.report.id).then(res => {
          if (this.state.isPublic) {
            this.changeStatus(COMPLETE_ID);
            sendNotifications({
              user,
              project: this.props.project,
              content: 'has published a report in',
              sendToClient: true,
              sendToAdmin: true,
              sendToPartner: false
            });
          }
          if (res.id !== undefined) {
            message.success('Updated successfully');
            setTimeout(() => {
              Router.reload();
            }, 1000);
          } else {
            message.error('Update failed!');
          }
        }).catch(error => {
          this.setState({
            isSubmitting: false
          });
          const foundMessage = error?.data?.message?.find(message => !!message);
          const nameError = foundMessage?.name?.join();
          if (nameError) {
            message.error(`Name: ${nameError}`);
          } else {
            message.error('An error occurred');
            console.error(error);
          }
        });
      });
    };
    this.changeStatus = value => {
      const param = {
        status: value
      };
      if (this.props.source !== 'batch') {
        changeStatusAction(this.props.projectId, param).catch(() => {});
      }
    };
    this.changeName = value => {
      this.setState({
        name: value.target.value
      });
    };
    this.changeExecSummary = value => {
      const execSummary = this.state.execSummary ?? {
        publish: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC,
        content: ''
      };
      execSummary.content = value.target.value;
      this.setState({
        execSummary
      });
    };
    this.changePublicExecSummary = value => {
      const execSummary = this.state.execSummary ?? {
        publish: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC,
        content: ''
      };
      execSummary.publish = value;
      this.setState({
        execSummary
      });
    };
    this.state = {
      ...DEFAULT_STATE,
      previewReport: false,
      isSubmitting: false,
      isUploading: false
    };
  }
  componentDidMount() {
    this.getReport();
  }
  render() {
    const {
      attachments,
      isSubmitting
    } = this.state;
    const iconRemove = {
      removeIcon: <FontAwesomeIcon style={{
        cursor: 'pointer'
      }} className="icon-remove" icon={faTrashAlt} />
    };
    const isProjectClosed = this.props.project.status === CLOSED_ID;
    return <S.ReportContainer>
        {this.props.project.can_publish ? null : <QANotice />}
        <Form name="basic" onFinish={this.onFinish}>
          <div className="new-report" data-testid="update-report">
            <Form.Item className="group-button">
              <Button data-public data-testid="discard-changes-button" disabled={isProjectClosed} type="primary" className="btn-report" loading={isSubmitting} onClick={this.getReport}>
                DISCARD CHANGES
              </Button>
              {!this.state.isPublic && <Button data-public data-testid="save-draft-button" type="primary" htmlType="submit" className="btn-report" loading={isSubmitting} onClick={() => this.setState({
              isPublic: false
            })}>
                  SAVE DRAFT
                </Button>}
              {this.state.previewReport ? <Button data-public data-testid="return-create-button" type="primary" className="btn-report" onClick={this.stopPreviewReport}>
                  EDIT REPORT
                </Button> : <Button data-public data-testid="preview-report-button" type="primary" className="btn-report" onClick={this.previewReport}>
                  PREVIEW REPORT
                </Button>}
              <Button data-public data-testid="publish-button" disabled={isProjectClosed || !this.props.project.can_publish} type="primary" htmlType="submit" className="btn-complete" loading={isSubmitting} onClick={() => this.setState({
              isPublic: true
            })}>
                PUBLISH
              </Button>
            </Form.Item>
            {this.state.previewReport ? <div className="report-view">
                <div className="text-center title">
                  <Title data-testid="report-name">
                    {this.state.name !== '' ? this.state.name : ''}
                  </Title>
                </div>

                {this.state.execSummary?.content && <div className="report-block">
                    <h6>Executive Summary</h6>
                    <div className="content">
                      {this.state.execSummary.content}
                    </div>
                  </div>}
                {attachments.length !== 0 && <div className="report-file">
                    <h6>Attachments</h6>
                    <div className="content">
                      {attachments.map(file => <p key={file.uid}>
                          <a href={file.thumbUrl} title="Attachment">
                            {file.name.substring(file.name.lastIndexOf('/') + 1).split('?')[0]}
                          </a>
                        </p>)}
                    </div>
                  </div>}
              </div> : <>
                <Input data-testid="name-report-input" type="dashed" disabled={isProjectClosed} placeholder="Name report" value={this.state.name} onChange={this.changeName} />
                {!this.state.isNameValid && <div style={{
              color: 'red'
            }}>
                    Please enter a name for your report
                  </div>}

                <div>
                  <div className="d-flex">
                    <p>Executive Summary</p>
                    {!isProjectClosed && <Select className="m-right" onChange={value => this.changePublicExecSummary(value)} defaultValue={this.state.execSummary && this.state.execSummary.publish ? this.state.execSummary.publish.toString() : REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC} showArrow suffixIcon={<CaretDownOutlined />}>
                        <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC}>
                          <FontAwesomeIcon icon={faEye} /> Everyone in Project
                        </Option>
                        <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE}>
                          <FontAwesomeIcon icon={faLock} /> Only Me
                        </Option>
                      </Select>}
                  </div>
                  <TextArea data-testid="executive-summary-input" disabled={isProjectClosed} placeholder="Start typing section here" onChange={value => this.changeExecSummary(value)} rows={8} defaultValue={this.state.execSummary && this.state.execSummary.content !== '' ? this.state.execSummary.content : ''} />
                </div>

                <div>
                  <div className="d-flex">
                    <p>Attachments</p>
                    {isProjectClosed && <Select className="m-right" onChange={attachmentPermission => this.setState({
                  attachmentPermission
                })} value={this.state.attachmentPermission.toString()} showArrow suffixIcon={<CaretDownOutlined />}>
                        <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC}>
                          <FontAwesomeIcon icon={faEye} /> Everyone in Project
                        </Option>
                        <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE}>
                          <FontAwesomeIcon icon={faLock} /> Only Me
                        </Option>
                      </Select>}
                  </div>
                  <div className="clearfix Attachments">
                    <Upload name="files" customRequest={async ({
                  file,
                  onSuccess,
                  onError
                }) => {
                  const formData = new FormData();
                  formData.append('files', file);
                  formData.append('project_id', String(this.props.projectId));
                  try {
                    const response = await uploadFile(formData);
                    onSuccess?.(response);
                  } catch (error) {
                    onError?.(error);
                  }
                }} fileList={attachments} onChange={onChange.bind(this)} multiple showUploadList={iconRemove}>
                      {!isProjectClosed && <Button data-public type="dashed" block className="btn-add-block report-name ">
                          <FontAwesomeIcon icon={faPlus} />
                          &ensp; Add Attachments
                        </Button>}
                    </Upload>
                  </div>
                </div>
              </>}
          </div>
        </Form>
      </S.ReportContainer>;
  }
}
export default UpdatePartnerReport;